export const linksResolver = doc => {
  const { uid, type } = doc

  const obj = {
    home: "/",
    blog_home: "/blog",
    blog: `/blog/${uid}`,
    page: `/${uid}`,
    research: `/research/${uid}`,
    event: `/event/${uid}`,
    webinar: `/webinar/${uid}`,
    person: `/team/${uid}`,
  }

  return obj[type] || "/"
}
